import React, { useState, useEffect } from 'react';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { Button, TextField, Typography, Paper, Container, Grid, Link, CircularProgress } from '@mui/material';
import PageLayout from '../components/PageLayout';
import { useAuth } from '../context/AuthContext';
import { useNotification } from '../context/NotificationContext';

function Register() {
    const { user } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const auth = getAuth();
    const notify = useNotification();

    useEffect(() => {
        if (user) {
            navigate('/join-auction');
        }
    }, [user, navigate]);

    const handleRegister = async (e) => {
        e.preventDefault();
        if (!name.trim()) {
            notify.error('Naam is verplicht.');
            return;
        }
        setLoading(true);

        try {
            // 1. Maak de gebruiker aan in Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // 2. Maak een bijbehorend document aan in de 'users' collectie in Firestore
            await setDoc(doc(db, "users", user.uid), {
                uid: user.uid,
                email: user.email,
                name: name,
                role: 'participant' // Standaardrol voor nieuwe gebruikers
            });

        } catch (err) {
            notify.error('Registratie mislukt. Het e-mailadres is mogelijk al in gebruik of het wachtwoord is te zwak.');
            console.error("Registration error:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageLayout>
            <Container component="main" maxWidth="xs">
                <Paper
                    component="form"
                    onSubmit={handleRegister}
                    elevation={6}
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        padding: 4
                    }}
                >
                    <Typography component="h1" variant="h5" gutterBottom>
                        Registreren
                    </Typography>
                    <TextField label="Naam" type="text" fullWidth margin="normal" value={name} onChange={e => setName(e.target.value)} required autoFocus />
                    <TextField label="E-mail" type="email" fullWidth margin="normal" value={email} onChange={e => setEmail(e.target.value)} required />
                    <TextField label="Wachtwoord" type="password" fullWidth margin="normal" value={password} onChange={e => setPassword(e.target.value)} required />
                    <Button type="submit" variant="contained" fullWidth sx={{ mt: 3, mb: 2 }} disabled={loading}>
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Registreren'}
                    </Button>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <Link component={RouterLink} to="/login" variant="body2">
                                Heb je al een account? Inloggen
                            </Link>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </PageLayout>
    );
}

export default Register;
